import { PlaceholderPage } from "../ui/PlaceholderPage";

export function DataCentersPage() {
  return (
    <PlaceholderPage title="Data centers" body="On-site generation tracker. v1.1 after Phase 5." />
  );
}
